import * as yup from 'yup';
import {
  UpdateEwebinarInput,
  EWebinarWithSetFragment,
  FullSetFragment,
} from '$/GraphQL/schema/schema';

export abstract class SettingsComponent<
  FormSchema = UpdateEwebinarInput,
  ValidationParams = unknown,
  PrepareDefaultValuesParams = EWebinarWithSetFragment,
  PrepareSubmitParams = FullSetFragment,
  PrepareSubmitReturn = FormSchema,
> {
  public abstract prepareDefaultValues(ewebinar: PrepareDefaultValuesParams): FormSchema;

  public abstract prepareSubmit(
    formData: FormSchema,
    set?: PrepareSubmitParams
  ): PrepareSubmitReturn | UpdateEwebinarInput;

  public abstract getValidationSchema(
    validationParams?: ValidationParams
  ): yup.Lazy<yup.AnyObjectSchema> | yup.AnyObjectSchema;
}
